import type {
	BaseSelection,
	BaseSelectionItem,
} from "@trydig/centra-types/selection";
import type { ProductDetails } from "../centra";
import { getBaseUrl } from "../utils";
import { selectionItemToKlaviyoItem } from "./utils";

declare global {
	interface Window {
		_klOnsite: Array<unknown[]>;
	}
}

export const klaviyoTracker = {
	addToCart: (selection: BaseSelection, item?: BaseSelectionItem) => {
		if (!window.klaviyo || !selection?.items || selection.items.length === 0)
			return;

		const addedItem = (item ||
			selection.items.at(selection.items.length - 1)) as
			| BaseSelectionItem
			| undefined;

		if (!addedItem) return;

		const baseUrl = getBaseUrl();

		const _ecommerce = {
			$value: selection?.totals?.grandTotalPriceAsNumber,
			AddedItemProductName: addedItem.product?.name,
			AddedItemProductID: addedItem.product?.productSku,
			AddedItemSKU: addedItem.product?.productSku,
			AddedItemCategories: addedItem.product?.categoryName,
			AddedItemImageURL: addedItem.product?.media?.standard?.[0],
			AddedItemURL: `${baseUrl}/${addedItem.product?.uri}`,
			AddedItemPrice: addedItem.priceEach,
			AddedItemQuantity: 1,
			ItemNames: selection.items.map((item) => item.product?.name),
			CheckoutURL: `${baseUrl}/checkout`,
			Items: selection?.items?.map(selectionItemToKlaviyoItem),
		};

		//window.klaviyo.track("Added to Cart", ecommerce);
	},
	viewProduct: (product: ProductDetails) => {
		if (!window.klaviyo) return;

		const baseUrl = getBaseUrl();

		const _ecommerce = {
			ProductName: product.name,
			ProductID: product.uri,
			SKU: product.sku,
			Categories: product.canonicalUri,
			ImageURL: product.media.at(0)?.href,
			URL: `${baseUrl}/${product.uri}`,
			Brand: "Kaos",
			Price: product?.priceAsNumber ?? 0,
			CompareAtPrice: product?.priceAsNumber ?? 0,
		};

		//window.klaviyo.track("Viewed Product", ecommerce);
	},
	startCheckout: (selection: BaseSelection, token?: string) => {
		if (!window.klaviyo || !selection?.items || selection.items.length === 0)
			return;

		const baseUrl = getBaseUrl();

		const _ecommerce = {
			$event_id: token,
			$value: selection?.totals?.grandTotalPriceAsNumber,
			ItemNames: [selection.items.map((item) => item.product?.name).join(", ")],
			CheckoutURL: `${baseUrl}/checkout`,
			Categories: new Set(
				selection.items.flatMap((item) => item.product?.categoryName),
			),
			Items: selection?.items?.map(selectionItemToKlaviyoItem),
		};

		//window.klaviyo.track("Started Checkout", ecommerce);
	},
	identify: (_email: string) => {
		if (!window.klaviyo) return;

		/*
		window.klaviyo.identify({
			email,
		});
		*/
	},
	identifyLocale: (language: string, country: string) => {
		try {
			const locale = `${language}-${country.toUpperCase()}`;

			if (window.klaviyo && typeof window.klaviyo.identify === "function") {
				window.klaviyo.identify({ $locale: locale });
			} else {
				const _klOnsite = (window._klOnsite = window._klOnsite || []);
				_klOnsite.push(["identify", { $locale: locale }]);
			}
		} catch (error) {
			console.error("[Klaviyo] identifyLocale error:", error);
		}
	},
};
